import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable() 
export class AllVideosDataService {


  private allVideoList = new BehaviorSubject('');
  allVideoListFromDB = this.allVideoList.asObservable();


  private currentFilteredList = new BehaviorSubject('');
  currentFilteredVideoList = this.currentFilteredList.asObservable();


  private searcheVideoList = new BehaviorSubject('');
  filteredSearchList = this.searcheVideoList.asObservable();

  private allInstructors = new BehaviorSubject('');
  allInstructorFromDB = this.allInstructors.asObservable();


  constructor() { }


  updateCurrentFilteredVideoList(filterObject: any) {
    this.currentFilteredList.next(filterObject)
  }

  updateSearchedVideosList(videoList: any) {
    this.searcheVideoList.next(videoList)
  }

  updateAllVideoList(videoList : any){
    this.allVideoList.next(videoList)
  }

  updateAllInstructos(instructorList : any){
      this.allInstructors.next(instructorList);
  }
  
  
  
  
}